import React from "react";
import { useNavigate } from "fusion-plugin-react-router";
import {
  downloadComplaintPolicy,
  downloadCookiePolicy,
  downloadTOBA,
} from "../utils/apiUtils";

const Footer = () => {
  const navigate = useNavigate();
  const openLegalDocument = (download) => download({ navigate });
  const footerLinkClassName =
    "tw-inline-flex tw-min-h-11 tw-items-center tw-text-inherit tw-font-semibold tw-underline tw-underline-offset-[3px]";
  const legalLinkClassName =
    "tw-font-semibold tw-text-white tw-underline tw-underline-offset-[3px]";

  return (
    <footer className="tw-m-0 tw-w-full tw-border-0 tw-bg-dis-navy tw-p-0 tw-text-left tw-text-[17px] tw-leading-[1.5] tw-text-white">
      <div className="tw-mx-auto tw-flex tw-max-w-[1200px] tw-flex-col tw-gap-[18px] tw-px-4 tw-pt-8 tw-pb-[100px] md:tw-px-10">
        <div className="tw-flex tw-flex-wrap tw-gap-x-[22px]">
          <a className={footerLinkClassName} href="tel:08009155160">Call 0800 915 5160</a>
          <a className={footerLinkClassName} href="mailto:support@driver-insurance.co.uk">Email us</a>
        </div>
        <nav aria-label="Legal">
          <ul className="tw-m-0 tw-flex tw-list-none tw-flex-wrap tw-gap-x-5 tw-p-0">
            <li><a className={footerLinkClassName} href="#terms" onClick={(event) => { event.preventDefault(); openLegalDocument(downloadTOBA); }}>Terms of Business</a></li>
            <li><a className={footerLinkClassName} href="/privacy">Privacy notice</a></li>
            <li><a className={footerLinkClassName} href="#cookies" onClick={(event) => { event.preventDefault(); openLegalDocument(downloadCookiePolicy); }}>Cookie policy</a></li>
            <li><a className={footerLinkClassName} href="#complaints" onClick={(event) => { event.preventDefault(); openLegalDocument(downloadComplaintPolicy); }}>Complaints</a></li>
          </ul>
        </nav>
        <div className="tw-flex tw-flex-col tw-gap-2 tw-border-t tw-border-x-0 tw-border-b-0 tw-border-solid tw-border-dis-footer-line tw-pt-4 tw-text-left tw-text-[13px] tw-leading-[1.55] tw-text-dis-footer-small">
          <p className="tw-m-0 tw-max-w-[120ch] tw-text-[13px] tw-text-dis-footer-small"><span translate="no">Uber Affinity UK Limited</span> are an Appointed Representative of <span translate="no">Freeway UK Insurance Services Limited</span> trading as <span translate="no">Driver Insurance Services</span>, <a className={legalLinkClassName} href="https://www.driver-insurance.co.uk" translate="no">www.driver-insurance.co.uk</a>, <span translate="no">Freeway</span>. <span translate="no">Freeway UK Insurance Services Ltd</span> are authorised and regulated by the Financial Conduct Authority (FCA) under firm reference number 306626. You may check this on the Financial Services Register by visiting the FCA's website, <a className={legalLinkClassName} href="https://www.register.fca.org.uk" translate="no">www.register.fca.org.uk</a> or by contacting the FCA on 0800 111 6768. Company is Registered in England No. 04030245. | All Rights Reserved</p>
          <p className="tw-m-0 tw-max-w-[120ch] tw-text-[13px] tw-text-dis-footer-small">Suite 3, 1100 Daresbury Pk, Daresbury, Warrington WA4 4HS</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
